import { AxiosResponse } from "axios";

export type EmailAPIError = AxiosResponse<{
  errors: { field: string; message: string }[];
}>;

export function isEmailApiError(error: unknown): error is EmailAPIError {
  if (
    error &&
    typeof error === "object" &&
    "data" in error &&
    typeof (error as AxiosResponse).data === "object"
  ) {
    const { data } = error as AxiosResponse;

    if (
      data &&
      "errors" in data &&
      Array.isArray(data.errors) &&
      data.errors.every(
        (e: { field: string; message: string }) =>
          typeof e.field === "string" && typeof e.message === "string"
      )
    ) {
      return true;
    }
  }

  return false;
}
